const modes = {
    simple: 'simple',
    normal: 'normal',
    import: 'import',
};

export {
    modes
};
